module.exports = __webpack_public_path__ + "static/media/slider-facebook.20527881.svg";